// store.js
import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null // Benutzer ist standardmäßig null
  },
  mutations: {
    setUser (state, user) {
      state.user = user // Setze die Benutzerdaten
    },
    clearUser (state) {
      state.user = null // Lösche die Benutzerdaten beim Logout
    }
  },
  actions: {
    saveUser ({ commit }, user) {
      commit('setUser', user) // Benutzer über eine Aktion speichern
    },
    logout ({ commit }) {
      commit('clearUser') // Benutzer-Logout
    }
  },
  getters: {
    getUser (state) {
      return state.user // Zugriff auf die Benutzerdaten
    },
    isLoggedIn (state) {
      return state.user !== null // Überprüfen, ob ein Benutzer eingeloggt ist
    }
  }
})
